import { useState, useCallback } from "react";
import { useLanguage } from "../context/LanguageContext";
import commonLanguage from "../language/commonLanguage";

/**
 * Custom hook for showing alerts and confirmations
 * @returns {Object} { showAlert, showConfirm, AlertComponent, ConfirmComponent }
 */
export function useAlert() {
  const { language } = useLanguage();
  const lang = commonLanguage[language];
  const [alertConfig, setAlertConfig] = useState(null);
  const [confirmConfig, setConfirmConfig] = useState(null);

  const showAlert = useCallback(
    ({ type = "info", title, message, confirmText = lang.ok }) => {
      return new Promise((resolve) => {
        setAlertConfig({
          type,
          title,
          message,
          confirmText,
          onClose: () => {
            setAlertConfig(null);
            resolve(true);
          },
        });
      });
    },
    [language]
  );

  const showConfirm = useCallback(
    ({
      type = "warning",
      title,
      message,
      confirmText = lang.confirm,
      cancelText = lang.cancel,
    }) => {
      return new Promise((resolve) => {
        setConfirmConfig({
          type,
          title,
          message,
          confirmText,
          cancelText,
          onConfirm: () => {
            setConfirmConfig(null);
            resolve(true);
          },
          onCancel: () => {
            setConfirmConfig(null);
            resolve(false);
          },
        });
      });
    },
    [language]
  );

  return {
    showAlert,
    showConfirm,
    alertConfig,
    confirmConfig,
  };
}
